var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotMap"},[_c('myMap',{attrs:{"fillCitys":_vm.fillCitys,"center":_vm.center,"Pzoom":13,"hotData":_vm.hotData,"g":_vm.g,"mapStyle":_vm.mapStyle,"max":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }